module.exports = __webpack_public_path__ + "console/img/mastek_small@1x.511ec6a5.png";